module.exports = __webpack_public_path__ + "static/media/email.2e17645c.svg";